"use strict";

var _interopRequireDefault = require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Loader = _interopRequireDefault(require("../Loader"));
var _jsxFileName = "/Users/mweeb/Desktop/codings/nq-component/src/Progress/index.js";
// This is deprecated and should be removed in the future
function Progress(props) {
  return /*#__PURE__*/_react["default"].createElement(_Loader["default"], Object.assign({}, props, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6,
      columnNumber: 12
    }
  }));
}
var _default = Progress;
exports["default"] = _default;